import React from 'react';
import { OrdersStat } from '../salesRepOrdersTypes';
import styles from './OrdersStatsRow.module.css';

interface OrdersStatsRowProps {
  stats: OrdersStat[];
}

const icons: Record<OrdersStat['icon'], string> = {
  orders: '📋',
  value: '$',
  profit: '↗',
  margin: '⊙',
};

export const OrdersStatsRow: React.FC<OrdersStatsRowProps> = ({ stats }) => {
  return (
    <div className={styles.row}>
      {stats.map((stat) => (
        <div key={stat.id} className={styles.card}>
          <span className={`${styles.iconBox} ${styles[`icon_${stat.color}`]}`}>
            {icons[stat.icon]}
          </span>
          <div>
            <p className={styles.label}>{stat.label}</p>
            <p className={`${styles.value} ${styles[`value_${stat.color}`]}`}>{stat.value}</p>
          </div>
        </div>
      ))}
    </div>
  );
};
